import { Injectable, inject, ViewChild } from '@angular/core';
import { tap, take, map, catchError, of } from 'rxjs';
import { child, Database, equalTo, listVal, objectVal, onValue, orderByChild, push, query, ref, remove, update } from '@angular/fire/database';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Storage, ref as refStorage, getDownloadURL, listAll, uploadBytes, deleteObject, uploadBytesResumable  } from '@angular/fire/storage';
import { getStorage, ref as refFS } from "firebase/storage";
import moment from 'moment';
import { iUsuario } from '../usuario/usuario.interface';

@Injectable({
  providedIn: 'root'
})
export class TableroService {
  private http = inject(HttpClient);
  private database: Database = inject(Database);
  private storage = inject(Storage);

  obtenerTablero (oUsuario: iUsuario) {
    return this.http.post(environment.tablero.estatus,{}).pipe(
      map((data: any) => {
        var temas = [];
        if(data.corporativo.length>0){
            var gCorpo: any = this.agrupaPorEstatus(data.corporativo, oUsuario);
            temas.push({id:'-KcOsYIkmr2FHgi4ubym', nombre: "Corporativo", 'vencidas' : gCorpo.vencidas, 'vigentes' : gCorpo.vigentes, 'xvencer' : gCorpo.xvencer})
        }
        if(data.corporativoConf.length>0){
            var gCorpConf: any = this.agrupaPorEstatus(data.corporativoConf, oUsuario);
            temas.push({id:'-KcOsYIoTX3wdcK4DMjF', nombre: "Corporativo Confidencial", 'vencidas' : gCorpConf.vencidas, 'vigentes' : gCorpConf.vigentes, 'xvencer' : gCorpConf.xvencer})
        }
        if(data.personal.length>0){
            var gPer: any = this.agrupaPorEstatus(data.personal, oUsuario);
            temas.push({id:'-KcOsYIprL1TVCF2uyaO', nombre: "Personal", 'vencidas' : gPer.vencidas, 'vigentes' : gPer.vigentes, 'xvencer' : gPer.xvencer})
        }
        if(data.personalConf.length>0){
            var gPerConf: any = this.agrupaPorEstatus(data.personalConf, oUsuario);
            temas.push({id:'-KdfegAIz9pHjb6ak32K', nombre: "Personal Confidencial", 'vencidas' : gPerConf.vencidas, 'vigentes' : gPerConf.vigentes, 'xvencer' : gPerConf.xvencer})
        }

        return temas;
      }),
      catchError((error) => {
        console.error("Error en obtenerTablero", error);
        return of({ error: true });
      })
    );
  }

  agrupaPorEstatus(oEntradas: any, oUsuario: iUsuario) {
    var grupo = {};
    var vencidas = []; 
    var vigentes = [];
    var xvencer = [];
    
    var userId = oUsuario.uid;
    var userRol = oUsuario.rol;

    for(var item in oEntradas){
        if((userRol == 1 && userId == oEntradas[item].analista) || (userRol == 2) || (userRol == 3) || (userRol == 4)) {
            var fechaInicioFormat = new Date(oEntradas[item].fechaInicio).toISOString().split('T')[0];
            var fechaFinFormat = new Date(oEntradas[item].fechaFin).toISOString().split('T')[0]
            oEntradas[item].fechaInicio = fechaInicioFormat;
            oEntradas[item].fechaFin = fechaFinFormat;

            if(oEntradas[item].porcentaje < 0.75){
                vigentes.push(oEntradas[item]);
            } else if(oEntradas[item].porcentaje >= 1){
                vencidas.push(oEntradas[item]);
            }else{
                xvencer.push(oEntradas[item]);
            }
        }
    }

    grupo = {'vencidas':vencidas, 'vigentes' : vigentes, 'xvencer' : xvencer};
    return grupo;
  }

  obtenerDescarga(oData: any) {
    return this.http.get(environment.tablero.descarga, {
      params: oData,
      headers: { "Content-Type": "application/json" },
      responseType: "arraybuffer",
    }).pipe(
      tap((data) => console.log("API Response", data)),
      take(1),
      map((data: any) => {
        return data;
      }),
      catchError((error: any) => {
        return of({
          error: true,
          message: "No se encontrarón datos para esta consulta.",
        } as unknown as any);
      })
    );
  }
}
